export default {
  title: 'Pripojiť {asset} k zdroju dát',
};
